import { render } from "./listModule.vue?vue&type=template&id=00be270f"
import script from "./listModule.vue?vue&type=script&lang=js"
export * from "./listModule.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__